import LayerMappingsEnum from "../../enums/LayerMappingsEnum";
import ISceneGeometry from "../sceneObject/ISceneGeometry";
import ExtrudedLoopAnnotationData from "../sceneObjectData/ExtrudedLoopAnnotationData";
import SceneObjectData from "../sceneObjectData/SceneObjectData";
import CompoundSceneGeometry from "./CompoundSceneGeometry";
import ExtrudedLoopSubGeometry2d from "./ExtrudedLoopSubGeometry2d";
import ExtrudedLoopSubGeometry3d from "./ExtrudedLoopSubGeometry3d";

// Compound geometry for any annotation extruded from a closed loop (Polygon/Rectangle/Circle):
// a flat top-down projection in 2D (ExtrudedLoopSubGeometry2d) and a wireframe/solid mesh in 3D
// (ExtrudedLoopSubGeometry3d), both held simultaneously and shown/hidden purely via the
// Annotations2d/Annotations3d camera layers (see SceneDirector) — not by any runtime toggle here.
// Reused directly (not subclassed) by all three shapes — each just passes its own concrete
// 2d/3d sub-geometry pair in, since the compound-wiring logic itself doesn't vary per shape.
export default class ExtrudedLoopCompoundGeometry<T extends ExtrudedLoopAnnotationData> extends CompoundSceneGeometry<T> {

    constructor(
        public readonly geometry2d: ExtrudedLoopSubGeometry2d<T>,
        public readonly geometry3d: ExtrudedLoopSubGeometry3d<T>
    ) {
        super();

        this.group.add(this.geometry2d.group);
        this.group.add(this.geometry3d.group);
    }

    protected getSubGeometries(): ISceneGeometry[] {
        return [this.geometry2d, this.geometry3d];
    }

    // Both sub-geometries keep their own independent area-label text, so both need to hear about
    // rotation-offset changes (unlike e.g. ChecklistItemCompoundGeometry, which only rotates its 2D half).
    onAnnotationDirectionChange(rotationOffset: number): void {
        this.geometry2d.onAnnotationDirectionChange(rotationOffset);
        this.geometry3d.onAnnotationDirectionChange(rotationOffset);
    }

    protected updateGeometry(data: SceneObjectData, forceUpdate: boolean): boolean {
        const result = super.updateGeometry(data, forceUpdate);

        this.geometry2d.setLayer(LayerMappingsEnum.Annotations2d);
        this.geometry3d.setLayer(LayerMappingsEnum.Annotations3d);

        return result;
    }
}
